var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEditTooltip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 1.5) scale(1.155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9.89167V11.9183C0 12.105 0.146667 12.2517 0.333333 12.2517H2.36C2.44667 12.2517 2.53333 12.2183 2.59333 12.1517L9.87333 4.87833L7.37333 2.37833L0.1 9.65167C0.0333334 9.71833 0 9.79833 0 9.89167ZM11.8067 2.945C12.0667 2.685 12.0667 2.265 11.8067 2.005L10.2467 0.445C9.98667 0.185 9.56667 0.185 9.30667 0.445L8.08667 1.665L10.5867 4.165L11.8067 2.945Z",
    fill: "#0065B3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditTooltip);
export default __webpack_public_path__ + "static/media/icon-edit-tooltip.57dee9d7d4f3b086561b7a27b6d0fc5c.svg";
export { ForwardRef as ReactComponent };